import {
  Component, ChangeDetectionStrategy, inject,
  input, output
} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";
import {TestResponse} from "../../../../../../shared/interfaces/ai-configuration";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-input-response',
  standalone: true,
  templateUrl: './input-response.component.html',
  styleUrls: ['./input-response.component.scss'],
  imports: [ReactiveFormsModule, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiTestResponseComponent {
  inputNumber = input.required<number>();
  formGroup = input.required<FormGroup>();
  controlName = input.required<string>();
  title = input<string>('Antwort');
  response = input<TestResponse | undefined>(undefined);
  isGenerating = input<boolean>(false);

  generateResponse = output<void>();

  private sanitizer = inject(DomSanitizer);

  get sanitizedHtml(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.response()!.response);
  }
}
